import React, { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { IConfigComponent } from '@ts/ui-models';
import { generateGlobalColumns, IDataGridConfig, TInheritedProps } from '@ts/storybook';

interface ItemRelationsTypeProps {
  configComponent?: IConfigComponent;
  inheritedProps?: TInheritedProps<false>;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'itemRelationTypes',
  aclId: 'tsElementRelationType',
  entity: 'itemRelationTypes',
  fetchURL: `/api/itemRelationTypes`,
};

const ItemRelationsType = (props: ItemRelationsTypeProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    const mixProps = { ...props, configComponent };
    const globalCells = generateGlobalColumns(mixProps);
    return [globalCells.id(), globalCells.name()];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      inheritedProps={inheritedProps}
    />
  );
};

export default ItemRelationsType;
